export default __webpack_public_path__ + "static/media/home.f4ab5f8c.mp4";